import StepList from '@/screensComponents/FinancialServices/StepList/StepList'

import { HeroBannerInfo } from '@/widgets/HeroBannerInfo'

import { SberBankLogo } from './assets/SberBankLogo'
import { catData, footerBannerData, stepListData } from './data'
import { FilteredCategories } from './ui/FiltredCategories/FiltredCategories'
import { FooterBanner } from './ui/FooterBanner/FooterBanner'

import cl from './styles.module.scss'

export const SberCredit = () => {
	return (
		<>
			<HeroBannerInfo
				title={
					<div>
						<SberBankLogo />
					</div>
				}
				image={{
					src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/sber/HeroBanner.png',
					height: 218,
					width: 480,
					style: { objectFit: 'contain' },
					alt: ''
				}}
				buttonLabel={''}
				text={<h2 className={cl.heroBannerTitle}>Электроника в рассрочку</h2>}
				additional={[
					{
						title: 'Всего за несколько минут',
						text: 'Короткая онлайн-анкета в СберБанк онлайн'
					},
					{
						title: 'Без первого взноса и переплат',
						text: 'Покупки сейчас — первый платёж через месяц'
					},
					{
						title: 'Срок от 6 до 12 месяцев',
						text: 'Комфортные платежи без переплаты'
					}
				]}
			/>
			<section className={cl.section}>
				<h2 className={cl.sectionTitle}>Как совершить покупку</h2>
				<StepList itemList={stepListData} />
			</section>
			<section className={cl.section}>
				<h2 className={cl.sectionTitle}>Товары в рассрочку</h2>
				<div className={cl.categoriesListWrapper}>
					<FilteredCategories data={catData} />
				</div>
			</section>
			<section className={cl.section}>
				<FooterBanner {...footerBannerData} />
				<p className={cl.notation}>
					Рассрочка — приобретение товара/услуги в кредит без увеличения затрат на приобретение товара/услуги за счет
					предоставления Партнером Банка (продавцом) скидки на товар/услугу. Увеличение затрат не происходит только в
					случае надлежащего исполнения заемщиком своих обязательств по кредитному договору. ПАО Сбербанк.
					«Потребительский кредит на покупку в интернет-магазинах». Генеральная лицензия Банка России на осуществление
					банковских операций № 1481 от 11.08.2015.
				</p>
			</section>
		</>
	)
}
